const escapeCsvField = (value: string | number): string =>
  `"${String(value).replace(/"/g, '""')}"`

/** Baixa um CSV no navegador. Não faz nada se `rows` estiver vazio. */
export const downloadCsv = (
  headers: string[],
  rows: (string | number)[][],
  filename: string
): void => {
  if (!rows.length) return

  const csvRows = [
    headers.join(','),
    ...rows.map((row) => row.map(escapeCsvField).join(',')),
  ]
  const csv = csvRows.join('\n')
  const bom = '﻿' // UTF-8 BOM — garante acentos no Excel
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()

  URL.revokeObjectURL(url)
}

/** `{prefix}-DD-MM-AAAA_HH-MM-SS.csv` — mesmo formato usado em todos os exports do app. */
export const buildCsvFilename = (prefix: string): string => {
  const now = new Date()
  const date = now.toLocaleDateString('pt-BR').replace(/\//g, '-')
  const time = now
    .toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    .replace(/:/g, '-')
  return `${prefix}-${date}_${time}.csv`
}
